import { useRef, useState, useCallback, useEffect } from 'react';
import { DIVIDER_WIDTH, MIN_WIDTH } from '../constants';
export const usePageSplit = ({ initialSize, minSize = MIN_WIDTH, splitType, }) => {
    const [size, setSize] = useState(undefined);
    const [separatorPosition, setSeparatorPosition] = useState(undefined);
    const [dragging, setDragging] = useState(false);
    const splitPaneRef = useRef(null);
    const updateSeparatorPosition = useCallback((position) => {
        if (splitType === 'vertical-divider') {
            setSeparatorPosition(position.X);
            setDragging(true);
        }
        if (splitType === 'horizontal-divider') {
            setSeparatorPosition(position.Y);
            setDragging(true);
        }
    }, [splitType]);
    const onMove = useCallback((clientPosition) => {
        if (dragging && size && separatorPosition) {
            const newSize = size + clientPosition - separatorPosition;
            if (newSize < minSize) {
                setSize(minSize);
                return;
            }
            if (splitPaneRef.current) {
                if (splitType === 'vertical-divider') {
                    const splitPaneWidth = splitPaneRef.current.clientWidth;
                    if (newSize > splitPaneWidth - minSize) {
                        setSize(splitPaneWidth - minSize);
                        return;
                    }
                }
                if (splitType === 'horizontal-divider') {
                    const splitPaneWidth = splitPaneRef.current.clientHeight;
                    if (newSize > splitPaneWidth - minSize) {
                        setSize(splitPaneWidth - minSize);
                        return;
                    }
                }
            }
            setSeparatorPosition(clientPosition);
            setSize(newSize);
        }
    }, [dragging, size, separatorPosition, minSize, splitPaneRef, splitType]);
    const updateMovePosition = useCallback((position) => {
        if (splitType === 'vertical-divider') {
            onMove(position.X);
        }
        if (splitType === 'horizontal-divider') {
            onMove(position.Y);
        }
    }, [onMove, splitType]);
    const onMouseDown = useCallback((e) => {
        updateSeparatorPosition({ X: e.clientX, Y: e.clientY });
    }, [updateSeparatorPosition]);
    const onTouchStart = useCallback((e) => {
        updateSeparatorPosition({
            X: e.touches[0].clientX,
            Y: e.touches[0].clientY,
        });
    }, [updateSeparatorPosition]);
    const onMouseMove = useCallback((e) => {
        e.preventDefault();
        updateMovePosition({ X: e.clientX, Y: e.clientY });
    }, [updateMovePosition]);
    const onTouchMove = useCallback((e) => {
        updateMovePosition({ X: e.touches[0].clientX, Y: e.touches[0].clientY });
    }, [updateMovePosition]);
    const onMouseUp = useCallback(() => {
        setDragging(false);
    }, []);
    useEffect(() => {
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('touchmove', onTouchMove);
        document.addEventListener('mouseup', onMouseUp);
        return () => {
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('touchmove', onTouchMove);
            document.removeEventListener('mouseup', onMouseUp);
        };
    });
    useEffect(() => {
        if (initialSize && !size) {
            setSize(initialSize);
        }
        if (!initialSize && !size && (splitPaneRef === null || splitPaneRef === void 0 ? void 0 : splitPaneRef.current)) {
            if (splitType === 'vertical-divider') {
                const halfSize = splitPaneRef.current.clientWidth / 2 - DIVIDER_WIDTH;
                setSize(halfSize);
            }
            if (splitType === 'horizontal-divider') {
                const halfSize = splitPaneRef.current.clientHeight / 2 - DIVIDER_WIDTH;
                setSize(halfSize);
            }
        }
    }, [initialSize, size, splitPaneRef, splitType]);
    return {
        splitPaneRef,
        size,
        setSize,
        onMouseDown,
        onTouchStart,
        onMouseUp,
    };
};
//# sourceMappingURL=usePageSplit.js.map